document.addEventListener('DOMContentLoaded', function() {
  const uk = window.Shopify && Shopify.country === 'GB';

  if (!uk) {
    document.querySelectorAll('variant-picker').forEach(picker => {
      const frameGroup = picker.querySelector('fieldset[data-option="Framing Options"]');
      if (!frameGroup) return;

      // Hide frame group completely
      frameGroup.style.display = 'none';
      frameGroup.style.visibility = 'hidden';
      frameGroup.style.height = '0';
      frameGroup.style.margin = '0';
      frameGroup.style.padding = '0';

      // Force Unframed selection
      const unframedBtn = frameGroup.querySelector('input[value="Unframed"]');
      if (unframedBtn) unframedBtn.checked = true;

      // Ensure Unframed stays selected on Add to Cart
      const addToCartBtn = picker.closest('form').querySelector('[type="submit"], .add-to-cart');
      if (addToCartBtn && unframedBtn) {
        addToCartBtn.addEventListener('click', function() {
          unframedBtn.checked = true;
        });
      }
    });
  }
});
